var render, staticRenderFns
import script from "./navGroup.vue?vue&type=script&lang=js"
export * from "./navGroup.vue?vue&type=script&lang=js"
import style0 from "./navGroup.vue?vue&type=style&index=0&id=84ad663c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ad663c",
  null
  
)

export default component.exports